<template>
<!-- eslint-disable max-len -->
<div>
  <div
    class="zone"
  >
    <div
      v-for="(videoItem, v) in videos"
      :key="`video${v}`"
      class="item"
      :style="mediaWrapperStyle"
    >
      <video
        class="media"
        :src="resolveAssetPath(videoItem.video, 'videos')"
        controls
        playsinline
        disablePictureInPicture
        controlslist="nodownload noplaybackrate"
      ></video>
    </div>
    <div
      v-for="(imageItem, m) in images"
      :key="`image${m}`"
      class="item"
      :style="mediaWrapperStyle"
      @click="() => expandImage(imageItem)"
    >
      <img
        class="media"
        :style="(shouldDisplayLabel && (imageItem.title || imageItem.description)) ? 'border-radius: 32px 32px 0 0;' : ''"
        :src="resolveAssetPath(imageItem.image, 'images')"
      />
      <div
        v-if="shouldDisplayLabel && (imageItem.title || imageItem.description)"
        class="media"
        :style="`
          color: white;
          width: 100%;
          text-align: center;
          height: 6rem;
          max-height: 6rem;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2rem;
          background-color: ${labelBackgroundColor};
          font-size: 1.5rem;
          border-radius: 0 0 32px 32px;`
          "
      >
        <div class="truncate"
          v-html="imageItem.title ? imageItem.title : imageItem.description"
        />
      </div>
    </div>
  </div>

  <!-- overlay for expanded images (videos have fullscreen control) -->
  <!-- absolute position fixes z-index popping... go figure -->
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div
      v-if="showExpandedImage && expandedImage"
      @click.stop="collapseImage"
      style="
        position: fixed;
        bottom: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 15000;
        background-color: rgba(0,0,0,0.5);
      "
    >
      <div
        style="
          position: absolute;
          top: 50px;
          left: 50px;
          height: 90%;
          width: 90%;
          z-index: 15000;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            gap: 8px;
          "
        >
          <button
            style="position: absolute; top: -40px; right: -40px; font-size: 50px;"
            @click.stop="collapseImage"
            class="btn btn-sm"
            autofocus
          >
            ×
          </button>
          <img
            style="max-width: 100%; height: 80%; object-fit: contain;"
            :src="resolveAssetPath(expandedImage.image, 'images')"
          />
          <p
            v-if="expandedImage.description"
            v-html="expandedImage.description"
            style="font-size: 30px; background-color: white; color: black; border-radius: 8px; padding: 8px;"
          ></p>
        </div>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    videos: { type: Array }, // strings
    images: { type: Array }, // strings
    shouldDisplayLabel: { type: Boolean, default: false },
  },
  data() {
    return {
      expandedImage: null,
      showExpandedImage: false,
    };
  },
  computed: {
    ...mapGetters([
      'game',
      'activeEnvironment'
    ]),
    mediaWrapperStyle() {
      return {
        background:
          this.shouldDisplayLabel ? 'transparent' :
            (this.game.mediaZoneItemBorderColor ? this.game.mediaZoneItemBorderColor : 'black'),
      };
    },
    labelBackgroundColor() {
      return this.activeEnvironment.navBarDropdownColor ? this.activeEnvironment.navBarDropdownColor : '#0D867B';
    }
  },
  methods: {
    collapseImage() {
      this.showExpandedImage = false;
    },
    expandImage(imageItem) {
      this.expandedImage = imageItem;
      this.showExpandedImage = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.zone {
  // size and position controlled via styles on this component in the parent
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
  align-items: center;
  gap: 24px;
  padding: 8px;
}

.item {
  flex: 100px 1 1;
  max-height: 100%;
  max-width: fit-content;
  border-radius: 8px;
  padding: 8px;
}

.media {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/MediaZone.vue